module.exports = "../../../../platform/assets/pageMainIcon/youth_danjuweihulei6.svg";